import { Link } from "react-router-dom";
import { Heart, Globe, BookOpen } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page" className="fade-in max-w-4xl mx-auto px-6 lg:px-12 py-16">
      <div className="overline mb-3">About this project</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-[#0F172A] leading-[1.05]">
        Why civic sense abroad matters.
      </h1>
      <p className="mt-6 text-[#475569] text-lg leading-relaxed">
        Every year, millions of Indians travel abroad — for tourism, work, study, business, and family.
        We carry our warmth, our food, our stories. But we also carry habits that don't always travel
        well: speaking too loudly on public transport, jumping queues, leaving litter, ignoring tipping
        norms, photographing strangers without asking, and treating laws as "guidelines."
      </p>
      <p className="mt-4 text-[#475569] text-lg leading-relaxed">
        Civic Sense Abroad is a free, honest guide — not to lecture, but to prepare. Because how
        you behave abroad shapes how India is remembered.
      </p>

      <div className="grid sm:grid-cols-3 gap-6 mt-12">
        <div className="card p-6">
          <Globe className="w-6 h-6 text-[#002FA7] mb-3" strokeWidth={1.5} />
          <h3 className="font-display font-semibold text-lg mb-1">9 Countries</h3>
          <p className="text-sm text-[#475569]">Detailed etiquette, dining, transport, and law briefs.</p>
        </div>
        <div className="card p-6">
          <BookOpen className="w-6 h-6 text-[#002FA7] mb-3" strokeWidth={1.5} />
          <h3 className="font-display font-semibold text-lg mb-1">Free Forever</h3>
          <p className="text-sm text-[#475569]">No paywalls. No sign-up. Built as a public good.</p>
        </div>
        <div className="card p-6">
          <Heart className="w-6 h-6 text-[#002FA7] mb-3" strokeWidth={1.5} />
          <h3 className="font-display font-semibold text-lg mb-1">Made with respect</h3>
          <p className="text-sm text-[#475569]">For Indian travelers, by Indians who travel.</p>
        </div>
      </div>

      <div className="mt-16 bg-[#0F172A] text-white rounded-sm p-10">
        <h2 className="font-display text-2xl font-bold tracking-tight">
          A note on tone.
        </h2>
        <p className="mt-3 text-white/80 leading-relaxed">
          We avoid stereotypes — both of foreign cultures and of ourselves. The goal isn't to make
          Indians feel bad; it's to make traveling Indians better-prepared. If you spot anything
          inaccurate or unfair, please write in.
        </p>
      </div>

      <div className="mt-12 text-center">
        <Link to="/quiz" data-testid="about-cta-quiz" className="btn-primary">Start with the Quiz</Link>
      </div>
    </div>
  );
}
